class CollectionBannersTest {
  constructor() {
    this.testVars = ['collectionBanner1Test', 'collectionBanner2Test'];
    this.applyState = this.applyState.bind(this);
    this.handleResize = this.debounce(this.applyState, 150);

    this.init();
  }

  init() {
    this.testVars.forEach((testVarName) => this.watchWindowVariable(testVarName));
    this.applyState();

    window.callbacks_pagination_after_change =
      window.callbacks_pagination_after_change || [];
    window.callbacks_pagination_after_change.push(this.applyState);

    window.callbacks_filters_after_render_products =
      window.callbacks_filters_after_render_products || [];
    window.callbacks_filters_after_render_products.push(this.applyState);

    window.addEventListener('resize', this.handleResize);
  }

  isActive(value) {
    return value === true || value === 'true';
  }

  applyState() {
    this.testVars.forEach((testVarName, index) => {
      const bannerIndex = index + 1;

      if (this.isActive(window[testVarName]) || this.isForced(bannerIndex)) {
        this.showBanner(bannerIndex);
      } else {
        this.removeBanner(bannerIndex);
      }
    });
  }

  isForced(bannerIndex) {
    const template = document.querySelector(
      `[data-collection-banner-template="${bannerIndex}"]`
    );
    const bannerElement = template?.content?.firstElementChild;

    return bannerElement?.dataset?.collectionBannerForce === 'true';
  }

  showBanner(bannerIndex) {
    const list = document.querySelector('.template-collection__products__list');
    const template = document.querySelector(
      `[data-collection-banner-template="${bannerIndex}"]`
    );

    if (!list || !template) {
      return;
    }

    this.removeBanner(bannerIndex);

    const bannerElement = template.content.firstElementChild;

    if (!bannerElement) {
      return;
    }

    const banner = bannerElement.cloneNode(true);
    banner.classList.remove('template-collection__banner--hidden');

    if (bannerIndex === 1) {
      list.prepend(banner);
      return;
    }

    const productItems = [
      ...list.querySelectorAll('.template-collection__products__item'),
    ];
    const targetProduct = this.getLastProductInFirstRow(productItems);

    if (targetProduct) {
      targetProduct.insertAdjacentElement('afterend', banner);
    } else {
      list.appendChild(banner);
    }
  }

  removeBanner(bannerIndex) {
    document
      .querySelectorAll(`[data-collection-banner="${bannerIndex}"]`)
      .forEach((banner) => banner.remove());
  }

  getLastProductInFirstRow(productItems) {
    if (!productItems.length) {
      return null;
    }

    const firstRowTop = productItems[0].offsetTop;
    return (
      productItems
        .filter((item) => item.offsetTop === firstRowTop)
        .pop() || productItems[0]
    );
  }

  watchWindowVariable(testVarName) {
    const descriptor = Object.getOwnPropertyDescriptor(window, testVarName);

    if (descriptor && !descriptor.configurable) {
      return;
    }

    let currentValue = window[testVarName];
    const enumerable = descriptor?.enumerable ?? true;
    const originalGetter = descriptor?.get;
    const originalSetter = descriptor?.set;

    Object.defineProperty(window, testVarName, {
      configurable: true,
      enumerable,
      get() {
        return originalGetter ? originalGetter.call(window) : currentValue;
      },
      set: (value) => {
        if (originalSetter) {
          originalSetter.call(window, value);
        } else {
          currentValue = value;
        }

        this.applyState();
      },
    });
  }

  debounce(callback, delay) {
    let timeoutId;

    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback(...args), delay);
    };
  }
}

export default CollectionBannersTest;
